import { z } from 'zod';

export const itemPedidoNovoSchema = z.object({
  produtoId: z.string().min(1, 'Produto ID é obrigatório'),
  quantidade: z.number().int().positive('A quantidade deve ser maior que zero'),
  precoUnitario: z.number().positive('O preço unitário deve ser maior que zero'),
});

export const novoPedidoSchema = z.object({
  clienteId: z.string().min(1, 'Cliente ID é obrigatório'),
  itens: z.array(itemPedidoNovoSchema).min(1, 'O pedido deve ter pelo menos um item'),
  orcamento: z.boolean().optional(),
  dataVencimento: z.string().optional(),
  numeroParcelas: z.number().int().min(1).max(12).optional(),
  dataPrimeiroVencimento: z.string().optional(),
  desconto: z.number().nonnegative('O desconto não pode ser negativo').optional(),
  acrescimo: z.number().nonnegative('O acréscimo não pode ser negativo').optional(),
});

export type NovoPedidoSchema = z.infer<typeof novoPedidoSchema>;
export type ItemPedidoNovoSchema = z.infer<typeof itemPedidoNovoSchema>;
